import axios from "axios";
import React, { useEffect, useState } from "react";

const CerImgComp = ({ imageUrl }) => {
  const [imgBase64, setImageBase64] = useState("");
  const getImageData = () => {
    axios
      .get(imageUrl)
      .then((response) =>
        setImageBase64(
          Buffer.from(response.data.image.data, "binary").toString("base64")
        )
      );
  };
  useEffect(() => {
    getImageData();
  }, []);
  return (
    <>
      <img
        style={{
          borderRadius: "10px 10px 0 0",
          height: "50%",
          objectFit: "cover",
          width: "100%",
        }}
        src={"data:image/jpeg;base64," + imgBase64}
        alt="templateImage"
      />
    </>
  );
};

export default CerImgComp;
